import React, { useState } from 'react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Button } from '../ui/button';
import { AddressFields } from './AddressFields';

export const StepDetails = ({ initial, onSubmit, onBack, taxData }) => {
  const [form, setForm] = useState({
    given_name: initial?.given_name || '',
    family_name: initial?.family_name || '',
    email: initial?.email || '',
    phone: initial?.phone || '',
    customer_note: initial?.customer_note || '',
    service_address: initial?.service_address || '',
    service_zip: initial?.service_zip || '',
    service_city: initial?.service_city || '',
  });
  const [errors, setErrors] = useState({});

  const set = (k, v) => setForm((p) => ({ ...p, [k]: v }));

  const validate = () => {
    const e = {};
    if (form.given_name.trim().length < 1) e.given_name = 'Required';
    if (form.family_name.trim().length < 1) e.family_name = 'Required';
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) e.email = 'Enter a valid email';
    if (form.phone.replace(/\D/g, '').length < 7) e.phone = 'Enter a valid phone';
    if (form.service_address.trim().length < 3) e.service_address = 'Required';
    if (!/^\d{5}$/.test(form.service_zip)) e.service_zip = 'Enter a 5-digit ZIP';
    if (!form.service_city) e.service_city = 'Select your city';
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const submit = (ev) => {
    ev.preventDefault();
    if (validate()) onSubmit(form);
  };

  return (
    <form onSubmit={submit} className="space-y-4" data-testid="booking-details-form">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <Label htmlFor="given_name" className="text-neutral-700">First Name *</Label>
          <Input
            id="given_name"
            value={form.given_name}
            onChange={(e) => set('given_name', e.target.value)}
            className="bg-white border-neutral-300 text-neutral-900 mt-1 h-12 sm:h-10 text-base"
            data-testid="input-given-name"
          />
          {errors.given_name && <p className="text-red-600 text-xs mt-1">{errors.given_name}</p>}
        </div>
        <div>
          <Label htmlFor="family_name" className="text-neutral-700">Last Name *</Label>
          <Input
            id="family_name"
            value={form.family_name}
            onChange={(e) => set('family_name', e.target.value)}
            className="bg-white border-neutral-300 text-neutral-900 mt-1 h-12 sm:h-10 text-base"
            data-testid="input-family-name"
          />
          {errors.family_name && <p className="text-red-600 text-xs mt-1">{errors.family_name}</p>}
        </div>
      </div>

      <div>
        <Label htmlFor="email" className="text-neutral-700">Email *</Label>
        <Input
          id="email"
          type="email"
          value={form.email}
          onChange={(e) => set('email', e.target.value)}
          className="bg-white border-neutral-300 text-neutral-900 mt-1 h-12 sm:h-10 text-base"
          data-testid="input-email"
        />
        {errors.email && <p className="text-red-600 text-xs mt-1">{errors.email}</p>}
      </div>

      <div>
        <Label htmlFor="phone" className="text-neutral-700">Phone *</Label>
        <Input
          id="phone"
          type="tel"
          value={form.phone}
          onChange={(e) => set('phone', e.target.value)}
          className="bg-white border-neutral-300 text-neutral-900 mt-1 h-12 sm:h-10 text-base"
          data-testid="input-phone"
        />
        {errors.phone && <p className="text-red-600 text-xs mt-1">{errors.phone}</p>}
      </div>

      <AddressFields form={form} set={set} errors={errors} taxData={taxData} />

      <div>
        <Label htmlFor="customer_note" className="text-neutral-700">Appointment Notes (Optional)</Label>
        <textarea
          id="customer_note"
          value={form.customer_note}
          onChange={(e) => set('customer_note', e.target.value)}
          rows={3}
          maxLength={1000}
          placeholder="Vehicle make/model, add-ons, access instructions, anything else we should know…"
          className="mt-1 w-full px-3 py-2 bg-white border border-neutral-300 rounded-sm text-neutral-900 placeholder-neutral-400 focus:outline-none focus:border-red-500"
          data-testid="input-customer-note"
        />
      </div>

      <div className="flex items-center gap-3 pt-2">
        <Button type="button" variant="outline" onClick={onBack} className="border-neutral-300 text-neutral-900 bg-white hover:bg-neutral-100">
          Back
        </Button>
        <Button type="submit" className="flex-1 bg-red-600 hover:bg-red-700" data-testid="step-details-continue">
          Continue to Payment
        </Button>
      </div>
    </form>
  );
};
